export default __webpack_public_path__ + "static/media/ethChainDefaultLogo.ebf6ef86.png";